<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import axios from "axios";
import Swal from "sweetalert2";
import Pagination from "@/router/layouts/table-pagination.vue";
import Datatable from "@/router/layouts/table-datatable.vue";
import _ from "lodash";

import ModalFormReferensi from "./components/modal-form-referensi.vue";

export default {
  page: {
    title: "Master Referensi",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Pagination,
    Datatable,
    ModalFormReferensi,
  },

  data() {
    let sortOrders = [];

    let columns = [
      { width: "50px", label: "No", name: "-" },
      { width: "auto", label: "User", name: "user" },
      { width: "auto", label: "Nama Referensi", name: "nama_referensi" }, // jika tidak ada sorting kasih name dengan karakter -
      { width: "300px", label: "Aksi", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -
    ];
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    const menu = "Master - Referensi";
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      title: menu,
      isWrite: localStorage.getItem("isWrite"),
      isRead: localStorage.getItem("isRead"),
      namePathUrl: this.$route.name,
      sessionRoleId: localStorage.session_role_active_id,
      user_name: localStorage.session_name,
      pathPhoto: localStorage.session_path_photo,
      pathPhotoFull:
        process.env.VUE_APP_BACKEND_URL + localStorage.session_path_photo,
      modalShow: false,
      loadingTable: false,
      tableData: [],
      columns: columns,
      sortKey: "nama_referensi",
      sortOrders: sortOrders,
      tableFilter: {
        page: 1,
        per_page: 10,
        nama_file: "",
        active_flag: 1,
        column: "idverif_file_referensi",
        dir: "asc",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },

      modalConfiguration: {
        referensi: false,
      },

      // variable form referensi
      selectedDataFormReferensi: null,
      formModeReferensi: "add",
    };
  },

  mounted() {
    if (this.isWrite != 1) this.columns.pop();
    this.filterData = _.debounce(this.getDataTable.bind(this), 500);
    this.getDataTable();
  },

  methods: {
    async getDataTable(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;

      const data = await axios({
        method: "get",
        url: this.BACKEND_URL_VERSION + "verifikasi/referensi",
        params: this.tableFilter,
        headers: { Authorization: `Bearer ${localStorage.access_token}` },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });

      if (data) {
        this.tableData = data.data.data;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },

    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      this.getDataTable(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getDataTable();
    },

    addReferensi() {
      this.formModeReferensi = "add";
      this.selectedDataFormReferensi = null;
      this.modalConfiguration.referensi = true;
    },

    changeStatus(id, newStatus) {
      const actionText = newStatus === 0 ? "menonaktifkan" : "mengaktifkan";
      Swal.fire({
        icon: "warning",
        title: `Apakah Anda yakin untuk ${actionText} data ini ?`,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "put",
            url:
              this.BACKEND_URL_VERSION +
              "verifikasi/referensi/" +
              id +
              "/status",
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err change status:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });

          if (data) {
            Swal.fire({
              icon: "success",
              title: 'Berhasil',
              text: `Data Berhasil di${actionText}`,
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false
            });
            this.getDataTable();
          }
        }
      });
    },

    destroy(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah anda yakin menghapus data ini secara permanen ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Ya",
        denyButtonText: "Tidak",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url: this.BACKEND_URL_VERSION + "verifikasi/referensi/" + id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });

          if (data) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil dihapus",
              timer: 1500,
              timerProgressBar: true,
              showConfirmButton: false
            });
            this.getDataTable();
          }
        }
      });
    },

    preview(data) {
      let path = data?.path_file ?? null;

      if (!path) {
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Tidak dapat preview file, file tidak ada.',
        });
        return;
      }

      let url = this.BACKEND_URL_VERSION + 'verifikasi/referensi/' + data.idverif_file_referensi + '/preview';
      
      Swal.fire({
        title: 'Preview File',
        text: 'Please wait . . .',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
 
      })

      axios({
        method: 'get',
        url: url,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`
        }
      }).then((res) => {
        console.log(res);
        window.open(this.BACKEND_URL + path, '_blank');
        Swal.close();
      }).catch((err) => {
        Swal.fire({
          icon: "error",
          title: "Gagal",
          text: err.response?.data?.data?.message || "Terjadi kesalahan.",
        });
      })
    },

    copyUrl(data) {
      let path = data?.path_file ?? null;

      if (!path) {
        Swal.fire({
          icon: 'info',
          title: 'Info',
          text: 'Tidak dapat copy path, path tidak ada.',
        });
        return;
      }
      navigator.clipboard.writeText(path);
      alert("Path berhasil di copy");
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />

    <div class="row">
      <div class="col-12">
        <!-- Content -->
        <div class="card">
          <div class="card-body">
            <!-- Filter -->
            <div class="row">
              <!-- Left: Select -->
              <div class="col-12 col-sm-2">
                <select
                  id="filterStatus"
                  class="form-control input-sm"
                  v-model="tableFilter.active_flag"
                  @change="getDataTable(true)"
                >
                  <option value="1">Aktif</option>
                  <option value="0">Tidak Aktif</option>
                </select>
              </div>

              <div class="col-12 col-sm-10 text-end">
                <b-button variant="primary" size="sm" @click="addReferensi">
                  <i class="fa fa-plus"></i>
                  Tambah
                </b-button>
              </div>
            </div>

            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i>
                      Loading
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(row, index) in tableData" :key="index">
                    <td class="text-center">{{ index + pagination.from }}</td>
                    <td class="text-center">{{ row?.user_role?.role_name ?? '-' }}</td>
                    <td>{{ row.nama_file }}</td>
                    <td v-if="isWrite == 1" class="text-center">
                      <div class="btn-group">
                        <b-button
                          variant="warning"
                          size="sm"
                          @click="preview(row)"
                        >
                          <i class="fa fa-eye me-1"></i>
                          Preview
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          variant="info"
                          size="sm"
                          @click="copyUrl(row)"
                        >
                          <i class="fa fa-copy me-1"></i>
                          Copy Path
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 1"
                          variant="danger"
                          size="sm"
                          @click="changeStatus(row.idverif_file_referensi, 0)"
                        >
                          <i class="fa fa-trash me-1"></i>
                          Disable
                        </b-button>

                        <b-button
                          v-if="tableFilter.active_flag == 0"
                          variant="success"
                          size="sm"
                          @click="changeStatus(row.idverif_file_referensi, 1)"
                        >
                          <i class="fa fa-recycle me-1"></i>
                          Enable
                        </b-button>

                        <button
                          v-if="tableFilter.active_flag == 0"
                          class="btn btn-danger btn-sm"
                          @click="destroy(row.idverif_file_referensi)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination
                :pagination="pagination"
                @to-page="toPage"
              ></Pagination>
            </div>

            <div class="row">
              <div class="col-12">
                <ModalFormReferensi
                  :show="modalConfiguration.referensi"
                  :data="selectedDataFormReferensi"
                  :mode="formModeReferensi"
                  @close="modalConfiguration.referensi = false"
                  @finish="getDataTable(1)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
